import apiMixin from "../../../mixins/apiMixin";

const BrandDeKonstrucktor = {
    namespaced: true,
    state: {
        /*To Show current view*/
        currentStep: 1,
        savedwordsbank: [],
        weburls: []

    },
    mutations: {
        /*Update current view*/
        setCurrentStep: function (state, payload) {
            state.currentStep = payload;

        },
        setSavedWordBank: function (state, payload) {
            state.savedwordsbank = payload;
        },
        setweburls: function (state, payload) {
            state.weburls = payload;
        }
    },
    actions: {
        setName: function (state, payload) {
            this.dispatch('BrandDeKonstrucktorMain/setName', payload, {root: true});
            if (state.rootState.BrandDeKonstrucktorMain.name) {
                state.commit('setCurrentStep', 2);
            }
        },
        submitSearch: function (state, payload) {
            this.dispatch('BrandDeKonstrucktorSearching/sendRequest', payload, {root: true}).then(response => {
                if (response.status === 200) {

                    localStorage.setItem('khonsu_search_token', JSON.stringify(response.data.search_token))
                    sessionStorage.setItem('_search_token', JSON.stringify(response.data.search_token));
                    return true;
                }
            }, error => {
                console.error(error)
            });
        },
        getWordBankByProjectName: async function (state, payload) {

            return apiMixin.methods.getWordBankByProjectName(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    state.commit('setSavedWordBank', response.data.words.split(','));

                    return true;

                });

        },
        getResult: function (state, payload) {

            this.dispatch('BrandDeKonstrucktorSearching/getResult', payload, {root: true}).then(response => {

                    if (response.data !== null) {
                        this.commit('BrandDeKonstrucktorSearching/setHistoryDekonstrucktorSummaryPage', true, {root: true})
                    }

                    if (response.data.social_search !== null) {
                        this.commit('BrandDeKonstrucktorSearching/setsocialSearch', response.data.social_search.results, {root: true})
                        sessionStorage.setItem('_search_token',response.data.social_search.search_token)
                    }
                    if (response.data.domain_search !== null) {
                        this.commit('BrandDeKonstrucktorSearching/setdomainSearch', response.data.domain_search.results, {root: true})
                        sessionStorage.setItem('_search_token',response.data.domain_search.search_token)
                    }
                    if (response.data.web_search !== null) {
                        // console.log(response.data.web_search.results)
                        this.commit('BrandDeKonstrucktorSearching/setwebSearch', response.data.web_search.results, {root: true})
                        sessionStorage.setItem('_search_token',response.data.web_search.search_token)
                        let arrayData = [];
                        for (let i = 0; i < response.data.web_search.results.length; i++) {
                            arrayData.push(response.data.web_search.results[i].url)
                        }
                        state.commit('setweburls', arrayData);


                    }

                    /* the trademark timer is set so when the trademark result is
                     not gotten within  a specific time period it returns empty*/
                    if (parseInt(sessionStorage.getItem('trademarktimer')) < 240) {
                        if (response.data.europeTrademarkSearch !== null) {
                            console.log(response.data.europeTrademarkSearch.results)
                            this.commit('BrandDeKonstrucktorSearching/settrademarkSearch', response.data.europeTrademarkSearch.results, {root: true})
                            sessionStorage.setItem('_search_token',response.data.europeTrademarkSearch.search_token)
                        }
                        if (response.data.unitedkingdomTrademarkSearch !== null) {
                            console.log("uk trademark results\n")
                            console.log(response.data.unitedkingdomTrademarkSearch.results)
                            this.commit('BrandDeKonstrucktorSearching/settrademark2Search', response.data.unitedkingdomTrademarkSearch.results, {root: true})
                            sessionStorage.setItem('_search_token',response.data.unitedkingdomTrademarkSearch.search_token)
                        }
                    }


                },
                error => {
                    console.error(error)
                });
        },
        getResultHistory: function (state, payload) {

            this.dispatch('BrandDeKonstrucktorSearching/getResult', payload, {root: true}).then(response => {

                    if (response.data !== null) {
                        this.commit('BrandDeKonstrucktorSearching/setHistoryDekonstrucktorSummaryPage', true, {root: true})
                    }

                    if (response.data.social_search !== null) {
                        this.commit('BrandDeKonstrucktorSearching/setsocialSearch', response.data.social_search.results, {root: true})

                    }
                    if (response.data.domain_search !== null) {
                        this.commit('BrandDeKonstrucktorSearching/setdomainSearch', response.data.domain_search.results, {root: true})
                    }
                    if (response.data.web_search !== null) {
                        // console.log(response.data.web_search.results)
                        this.commit('BrandDeKonstrucktorSearching/setwebSearch', response.data.web_search.results, {root: true})
                        let arrayData = [];
                        for (let i = 0; i < response.data.web_search.results.length; i++) {
                            arrayData.push(response.data.web_search.results[i].url)
                        }
                        state.commit('setweburls', arrayData);



                    }

                    if (response.data.europeTrademarkSearch !== null) {
                        this.commit('BrandDeKonstrucktorSearching/settrademarkSearch', response.data.europeTrademarkSearch.results, {root: true})
                    }
                    if (response.data.unitedkingdomTrademarkSearch !== null) {
                        console.log("uk trademark results\n")
                        console.log(response.data.unitedkingdomTrademarkSearch.results)
                        this.commit('BrandDeKonstrucktorSearching/settrademark2Search', response.data.unitedkingdomTrademarkSearch.results, {root: true})
                    }


                },
                error => {
                    console.error(error)
                });
        },
        getSearchCountValues: function (state, payload) {
            return this.dispatch('BrandDeKonstrucktorSearching/getSearchCount', payload, {root: true})
        },
        getHistory: function (state, payload) {

            this.dispatch('SearchHistory/getHistory', payload, {root: true}).then(response => {
                    /*
                    set the history state after the searchHistory in the search Module
                     */
                    this.commit('SearchHistory/setHistory', response.data, {root: true});
                    // this.commit('SearchHistory/setTotalRecord', response.data.total, {root: true});
                    // this.commit('SearchHistory/setPreviousUrl', response.data.prev_page_url, {root: true});
                    // this.commit('SearchHistory/setNextUrl', response.data.next_page_url, {root: true});
                    // console.log(response.data.data);
                },
                error => {
                    console.error(error)
                });
        }


    },
    getters: {
        getCurrentStep: function (state) {
            return state.currentStep;
        },
    },
}
export default BrandDeKonstrucktor
